import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { MaterialReactTable } from "material-react-table";
import { useState } from "react";
import { tableConfig } from "./config/tableConfig";
import TitleContainer from "./utilsTable/titleWithFetchData";

const DatacenterPrestadoresTable = ({ data, loading, fetchData, handleOpenEdit }) => {
  const [columnObject] = useState([
    {
      header: "ART",
      accessorKey: "artNombre",
    },
    {
      header: "CUIT",
      accessorKey: "cuit",
    },
    {
      header: "Razón social",
      accessorKey: "razonSocial",
    },
    {
      header: "Nombre fantasía",
      accessorKey: "nombreFantasia",
    },
    {
      header: "Código Prestador ART",
      accessorKey: "codigoPrestadorArt",
    },
    {
      header: "Acciones",
      Cell: ({ row }) => (
        <Box display="flex">
          <Tooltip title="Editar Prestador Datacenter">
            <IconButton color="inherit" onClick={() => handleOpenEdit(row.original)} aria-label="edit">
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ]);

  return (
    <MaterialReactTable
      {...tableConfig}
      columns={columnObject}
      data={data}
      state={{ isLoading: loading }}
      renderTopToolbarCustomActions={() => (
        <Box m={0.5}>
          <TitleContainer title="Prestadores DataCenter" fetchData={fetchData} />
        </Box>
      )}
    />
  );
};

export default DatacenterPrestadoresTable;